import * as urls from "../../../api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import MasterPage1Column from "pages/MasterPage1Column";
import Select, { components, useStateManager } from 'react-select';
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import SelectDropdownAsyncWpTags from "components/SelectDropdownAsyncWpTags";
import { DropdownOption } from "types";


const GeneralSettingComponent: React.FC<{}> = ({ }) => {
  const { dispatch, useAppSelector } = useRedux();
  const [ddlUser, setDdlUser] = useState<any[]>([]);
  const [userToAddRemove, setUserToAddRemove] = useState<any[]>([]);
  const [supplierUserToAddRemove, setSupplierUserToAddRemove] = useState<any[]>([]);
  const [initTagRecureTask, setInitTagRecureTask] = useState<DropdownOption[]>([]);

  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      isAdmin: p2.isAdmin,
    })
  );
  const { isAdmin } = useAppSelector(storeData);


  useEffect(() => {
    const rs = new APIClient().fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL, {})
      .then(rs => {
        // console.log('SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL:', rs);
        setDdlUser(rs);
      })
      .catch(er => Utils.HandleException(er, true));

    const rs2 = new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setUserToAddRemove(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setSupplierUserToAddRemove(forDll);
      }).catch(er => Utils.HandleException(er, true));

    const initTag = new APIClient().fnPostForm(urls.UC_INIT_TAG_IN_RECURANCE_TASK_LOAD, {})
      .then(rs => {
        setInitTagRecureTask(rs);
      }).catch(er => Utils.HandleException(er, true));
  }, []);

  const onSave2sOnline = () => {
    try {
      const userId = userToAddRemove.map((x: any) => x.value);
      if (userId.length <= 0) {
        alert('ไม่มีข้อมูล');
      } else {
        new APIClient().fnPostForm(urls.SAVE_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE, { userIds: userId })
          .then(rs => alert('บันทึกสำเร็จ'))
          .catch(er => Utils.HandleException(er, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onSaveSupplierReceptance = () => {
    try {
      const userId = supplierUserToAddRemove.map((x: any) => x.value);
      if (userId.length <= 0) {
        alert('ไม่มีข้อมูล');
      } else {
        new APIClient().fnPostForm(urls.SAVE_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE, { userIds: userId })
          .then(rs => alert('บันทึกสำเร็จ'))
          .catch(er => Utils.HandleException(er, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onSaveInitTagRecureTask = () => {
    try {
      const tagIds = initTagRecureTask.map(x => x.value).join(',');
      new APIClient().fnPostForm(urls.UC_INIT_TAG_IN_RECURANCE_TASK_SAVE, { tagIds: tagIds })
        .then(rs => alert('บันทึกสำเร็จ'))
        .catch(er => Utils.HandleException(er, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          พนักงานเข้าห้องแชท 2sonline กรณีลูกค้าใหม่ ลงทะเบียนมาเอง
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                // className="form-control"
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setUserToAddRemove(e)}
                value={userToAddRemove}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={onSave2sOnline}>Save</button>
            }
          </div>
        </div>
      </div >

      <div className="row">
        <div className="col">
          พนักงานเข้าห้องแชท supplier กรณี supplier ใหม่ ลงทะเบียนมาเอง
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setSupplierUserToAddRemove(e)}
                value={supplierUserToAddRemove}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={onSaveSupplierReceptance}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          Tag เริ่มต้นสำหรับ Tag เข้างานประจำ
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <SelectDropdownAsyncWpTags onValueChanged={(e) => setInitTagRecureTask(e)} selectedValues={initTagRecureTask} />
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={onSaveInitTagRecureTask}>Save</button>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const DataSettingGeneral = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  return (
    <MasterPage1Column
      titleText="กำหนดค่าการทำงานทั่วไป"
      titleIcon="fa fa-gears"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<GeneralSettingComponent />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingGeneral;